export const checkFeatures = (): boolean => {
  // Check features if cookies are enabled
  const isCookiesEnabled = navigator.cookieEnabled;
  return isCookiesEnabled;
};
